<script>
import Layout from '@layout/main'
import SectionPlan from './components/SectionPlan'
import SectionMarketingPlan from './components/SectionMarketingPlan'
import SectionCompare from './components/SectionCompare'
import SectionContact from './components/SectionContact'

export default {
  page() {
    return {
      title: '方案價格',
    }
  },
  components: {
    Layout,
    SectionPlan,
    SectionCompare,
    SectionContact,
    SectionMarketingPlan
  },
}
</script>
<template>
  <Layout>
    <div class="header__bg">
      <BaseBannerTitle 
        title="方案價格" 
        sub-title="Pricing" 
      />
    </div>
    <SectionPlan/>
    <!-- <SectionMarketingPlan/> -->
    <!-- <SectionCompare/> -->
    <SectionContact/>
  </Layout>
</template>
<style lang="scss" module>

</style>